<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="title">{{ 'SEND_REGISTRATION_KEY_FORM.HEADER' | translate }}</div>
  <div>
    <app-select [control]="form.controls['language']" [itemsSource]="languages"></app-select>
    <app-email-box [control]="form.controls['email']"></app-email-box>
  </div>
  <div>
    <button class="btn btn-active" type="submit">OK</button>
    <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
  </div>
</form>
